// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconComponent } from '@lbca-shared/icon';
import { insert as insertRamda } from 'ramda';
import { GetItemLocalStoragePipe } from '../../../../../pipes/getItemLocalStorage.pipe';
import { BodyFeedbackComponent } from '../../../body-feedback/body-feedback.component';
import { InputTextComponent } from '../../../fields/input-text/input-text.component';
import { ModalDirective, ModalInterfaceComunication } from '../../../modal-overlay/modal.directive';
import { TableSecondaryComponent } from '../../../table-secondary/table-secondary.component';
import { DynamicFormService } from '../../dynamic-form.service';
import { ClaimService } from '../claim/claim.service';
import { LegalRequestFormComponent } from './legal-request-form/legal-request-form.component';

@Component({
  selector: 'lbca-legalboxplus-legal-request',
  templateUrl: './legal-request.component.html',
  styleUrl: './legal-request.component.scss',
  imports: [
    InputTextComponent,
    BodyFeedbackComponent,
    TableSecondaryComponent,
    LegalRequestFormComponent,
    GetItemLocalStoragePipe,
    IconComponent,
  ],
})
export class LegalRequestComponent implements OnInit {
  private overlay = inject(Overlay);
  private modalController = new ModalInterfaceComunication();

  @Input() configuration: any;

  @Input('cardData') cardInfo: any;

  @Input() simple: any;

  @Input('dataAttr') set data(data: any) {
    this.dataAttr = data;
    this.processId = this.dataAttr.processNumber;
    this.taskId = this.dataAttr?.bpmIdCard;
  }

  @ViewChild('actionsExcluirRender', { static: true })
  actionsExcluirRender: ElementRef | undefined;

  @ViewChild('actionsEditRender', { static: true })
  actionsEditRender: ElementRef | undefined;

  @ViewChild('ModalEdit') editModal: TemplateRef<any> | undefined;
  @ViewChild('ModalRegisterTemplate') registerModal: TemplateRef<any> | undefined;

  lbcaModal = new ModalDirective(this.overlay, this.modalController);

  public loadPage = false;
  public taskId = '';
  public processId: string | undefined;
  public dataAttr: any;
  public line: any;
  public lineremove: any;
  public legalRequestEdit!: Record<string, any>;

  public generalDataNoPhase = [
    {
      icon: 'quantidade-',
      label: 'Quantidade',
      value: '-',
    },
    {
      icon: 'total-inicial-',
      label: 'Total Inicial',
      value: '-',
      mask: 'CURRENCY_BR',
    },
    {
      icon: 'total-atualizado-',
      label: 'Total Atualizado',
      value: '-',
      mask: 'CURRENCY_BR',
    },
    {
      icon: 'risco-',
      label: 'Total Risco Envolvido',
      value: '-',
      mask: 'CURRENCY_BR',
    },
  ];

  public tableLegalRequest: any = {
    config: { highlight: () => true },
    columns: [
      {
        name: 'typeId',
        label: 'Pedido',
        type: 'data',
        orderDefault: false,
        order: false,
        col: 5,
        field: {
          size: 2,
          entityKey: 'typeId',
          label: 'Pedido',
          type: 'SELECT_ONE',
          disabled: true,
          auxEntity: {
            entityUrl: '/legal-request/drop-data',
            tableName: 'legal-request-type',
          },
        },
      },
      {
        name: 'dateReference',
        label: 'Data de referência',
        type: 'data',
        orderDefault: true,
        order: false,
        col: 3,
        field: {
          size: 3,
          entityKey: 'dateReference',
          disabled: true,
          label: 'Data de referência',
          type: 'CALENDAR',
        },
      },
      {
        name: 'primaryValue',
        label: 'Valor Inicial',
        type: 'data',
        orderDefault: false,
        order: false,
        col: 3,
        field: {
          size: 3,
          entityKey: 'primaryValue',
          disabled: true,
          label: 'Valor Inicial',
          type: 'TEXT',
          mask: 'CURRENCY_BR',
        },
      },
      {
        name: 'endValue',
        label: 'Valor pago',
        type: 'data',
        orderDefault: false,
        order: false,
        col: 3,
        field: {
          size: 3,
          entityKey: 'endValue',
          disabled: true,
          label: 'Valor pago',
          type: 'TEXT',
          mask: 'CURRENCY_BR',
        },
      },
    ],
    details: [
      {
        name: 'description',
        label: 'Pedido',
        type: 'data',
        orderDefault: false,
        order: false,
        col: 7,
        field: {
          type: 'TEXTAREA',
          entityKey: 'description',
          label: 'Pedido',
          size: 7,
        },
      },
      {
        type: 'data',
        orderDefault: true,
        order: false,
        col: 7,
        field: {
          type: 'ADDITIONAL_VALUES_CONDENSED',
          size: 7,
          fields: [
            {
              label: 'Principal',
              entityKey: 'hasPrimary',
              fields: [
                [
                  {
                    size: 3,
                    entityKey: 'financialCode',
                    disabled: true,
                    label: 'Linha Digitável',
                    type: 'TEXT',
                  },
                  {
                    entityKey: 'riskCalculate',
                    disabled: true,
                    label: 'Risco envolvido',
                    size: 3,
                    type: 'TEXT',
                    mask: 'CURRENCY_BR',
                  },
                  {
                    size: 3,
                    entityKey: 'primaryValue',
                    label: 'Valor Inicial',
                    type: 'TEXT',
                    mask: 'CURRENCY_BR',
                    required: true,
                    editable: false,
                  },
                  {
                    auxEntity: {
                      entityUrl: '/legal-request/getIndexes',
                      tableName: 'legal-request-indexes',
                    },
                    size: 3,
                    entityKey: 'primaryIndexId',
                    disabled: true,
                    label: 'Índice de Correção',
                    type: 'SELECT_ONE',
                  },
                ],
              ],
            },
            {
              label: 'Juros',
              entityKey: 'hasInterest',
              fields: [
                [
                  {
                    auxEntity: {
                      entityUrl: '/task/drop-data',
                      tableName: 'interest',
                    },
                    size: 7,
                    entityKey: 'interestType',
                    disabled: true,
                    label: 'Tipo de Juros',
                    type: 'RADIO',
                    forceType: 'RADIO',
                  },
                ],
                [
                  {
                    size: 3,
                    entityKey: 'interestDateReference',
                    label: 'Data de referência',
                    type: 'CALENDAR',
                  },
                  {
                    size: 2,
                    entityKey: 'interestPercents',
                    label: 'Porcentagem',
                    mask: 'PERCENTS_v2',
                    type: 'TEXT',
                  },
                ],
              ],
            },
            {
              label: 'Multa',
              enabled: false,
              required: true,
              entityKey: 'hasPenalty',
              fields: [
                [
                  {
                    size: 2,
                    entityKey: 'penaltyPercents',
                    disabled: false,
                    label: 'Porcentagem',
                    type: 'TEXT',
                    mask: 'PERCENTS_v2',
                  },
                ],
              ],
            },
          ],
        },
      },
      {
        type: 'data',
        orderDefault: true,
        order: false,
        col: 7,
        field: {
          disabled: false,
          entityKey: 'emailList',
          helperText: '',
          configuration: {
            primary: [
              {
                disabled: false,
                entityKey: 'email',
                helperText: '',
                label: 'E-mail',
                required: true,
                size: 7,
                type: 'TEXT',
              },
            ],
          },
          label: 'E-mails',
          size: 7,
          type: 'TABLE_LIST',
        },
      },
      {
        type: 'data',
        orderDefault: true,
        order: false,
        col: 7,
        field: {
          disabled: false,
          entityKey: 'urlList',
          helperText: '',
          configuration: {
            primary: [
              {
                disabled: false,
                entityKey: 'url',
                helperText: '',
                label: 'URL',
                required: true,
                size: 7,
                type: 'TEXT',
              },
            ],
          },
          label: 'URLs',
          size: 7,
          type: 'TABLE_LIST',
        },
      },
      {
        type: 'data',
        orderDefault: true,
        order: false,
        col: 7,
        field: {
          disabled: false,
          entityKey: 'ipList',
          helperText: '',
          configuration: {
            primary: [
              {
                disabled: false,
                entityKey: 'ip',
                helperText: '',
                label: 'IP',
                required: true,
                size: 7,
                type: 'TEXT',
                mask: 'IP',
              },
            ],
          },
          label: "IP's",
          size: 7,
          type: 'TABLE_LIST',
        },
      },
      {
        type: 'data',
        orderDefault: true,
        order: false,
        col: 7,
        field: {
          disabled: false,
          entityKey: 'accountIdList',
          helperText: '',
          configuration: {
            primary: [
              {
                disabled: false,
                entityKey: 'accountId',
                helperText: '',
                label: 'ID conta ADS/Workspace',
                required: true,
                size: 7,
                type: 'TEXT',
                mask: 'ONLY_NUMBERS',
              },
            ],
          },
          label: 'IDs',
          size: 7,
          type: 'TABLE_LIST',
        },
      },
    ],
    body: [],
    loaded: false,
  };

  constructor(
    private claimService: ClaimService,
    private route: ActivatedRoute,
    private router: Router,
    private dynamicFormService: DynamicFormService,
  ) {}

  ngOnInit() {
    // const { params } = this.route.snapshot;
    // const regexBase = new RegExp("/base/");
    // const regexTask = new RegExp("/task/");
    // if (regexTask.test(this.router.url)) {
    //   this.taskId = params.id;
    // } else if (regexBase.test(this.router.url)) {
    //   this.taskId = "base";
    // } else {
    //   this.taskId = "createCase";
    // }

    this.tableLegalRequest.columns = insertRamda(
      0,
      {
        name: 'content',
        type: 'action-delete',
        functionDelete: (element: any) => this.confirmDelete(element),
        col: 1,
      },
      this.tableLegalRequest.columns,
    );

    if (!this.configuration?.readOnly) {
      this.tableLegalRequest.columns.push({
        label: 'Editar',
        type: 'data',
        cssHeader: 'text-center',
        templateRef: this.actionsEditRender,
        order: true,
        col: 1,
      });
      this.tableLegalRequest.columns.push({
        label: 'Excluir',
        type: 'data',
        cssHeader: 'text-center',
        templateRef: this.actionsExcluirRender,
        order: true,
        col: 1,
      });
    }

    this.loadData();
  }

  private loadData() {
    const taskId = this.taskId;
    const processId = this.processId;
    const context = 'legalRequest';

    const params: any = {
      taskId,
      context,
    };
    if (!this.configuration.shouldExcludeProcessId) {
      params.processId = processId;
    }

    if (this.configuration.notHasPhase) {
      this.claimService.request(params).subscribe(
        (resp: any[any]) => {
          this.tableLegalRequest.body = resp;
          this.tableLegalRequest.loaded = true;

          this.generalDataNoPhase[0].value = String(resp.length); // Quantidade total
          this.generalDataNoPhase[1].value = resp
            .reduce((acc: any, cur: any) => acc + Number(cur.primaryValue), 0)
            .toFixed(2); // Total Inicial
          this.generalDataNoPhase[2].value = resp
            .reduce(
              (acc: any, cur: any) =>
                acc +
                Number(cur.primaryValueCorrectBalance) +
                Number(cur.penaltyValue) +
                Number(cur.interestValue),
              0,
            )
            .toFixed(2); // Total Atualizado

          this.generalDataNoPhase[3].value = resp
            .reduce((acc: any, cur: any) => acc + Number(cur.riskCalculate), 0)
            .toFixed(2); // Total Risco Envolvido

          this.loadPage = true;
        },
        (err: any) => {
          // return this.defautlFeedbackServerError(err);
          console.log(err);
        },
      );
    } else {
      this.loadPage = true;
    }
  }

  public openModalPhase() {}

  public openRegisterModal() {
    if (!this.registerModal) return;
    this.modalController.showModal(this.registerModal);
  }

  public deleteItem($event, lane) {
    lane.deleted = !lane.deleted;
    this.line = { id: lane.id, status: lane.deleted };
  }

  private async confirmDelete(legalRequest) {
    this.lineremove = { id: legalRequest.id };
    legalRequest.confirmDelete = !legalRequest.confirmDelete;

    if (this.configuration.notHasPhase) {
      this.tableLegalRequest.body = this.tableLegalRequest.body.filter(
        ({ id }: { id: string }) => id !== legalRequest.id,
      );
    } else {
      const phaseId = legalRequest?.phaseId;

      if (!phaseId) return;
      //   return this.defautlFeedbackServerError(`Erro de phaseId não encontrada`);

      // const steps = this.tableDataClaim[phaseId].body;

      // if (steps) {
      //   const newBody = steps.filter((removeStep) => removeStep.id !== lane.id);
      //   this.tableDataClaim[phaseId].body = newBody;
      // }
    }

    const taskId = this.taskId;

    const body = JSON.parse(JSON.stringify(legalRequest));
    body.deleted = true;

    const params = { id: body.id, taskId };

    this.claimService.editClaim(body, params).subscribe(
      (resp: any) => {
        if (!resp?.errors) {
          this.loadData();
        }
      },
      (err: any) => console.log(err),
    );
  }

  public closeModal() {
    this.legalRequestEdit = null as any;

    this.modalController.closeModal();
    this.loadData();
  }

  public editItem($event, legalRequest) {
    this.legalRequestEdit = JSON.parse(JSON.stringify(legalRequest));

    this.openEditModal();
  }

  public openEditModal(): void {
    if (!this.editModal) return;
    this.modalController.showModal(this.editModal);
  }
}
